import { superExtraSection, superClientsMenu } from "../helpers/constant";

export default {
  getSection(clientInfo) {
    let section = [];
    if (clientInfo && clientInfo.length > 0) {
      for (let i = 0; i < clientInfo.length; i++) {
        section.push(
          this.addSection(clientInfo[i].value, clientInfo[i].ownerShort)
        );
      }
    }
    section.push(this.addSection(superExtraSection.id, superExtraSection.name));
    return section;
  },
  addSection(id, name) {
    return { id: id, name: name };
  },

  getMenus(sections, selectedMenu, selectedSection) {
    let menus = [];
    for (let i = 0; i < sections.length; i++) {
      for (let j = 0; j < superClientsMenu.length; j++) {
        let isAddMenu = false;
        let isActive = false;
        if (
          superClientsMenu[j].isClientWise &&
          sections[i].id != superExtraSection.id
        ) {
          isAddMenu = true;
        } else if (
          !superClientsMenu[j].isClientWise &&
          sections[i].id == superExtraSection.id
        ) {
          isAddMenu = true;
        }
        if (
          selectedSection == sections[i].id &&
          selectedMenu == superClientsMenu[j].id
        ) {
          isActive = true;
        }
        if (isAddMenu) {
          menus.push({
            sectionId: sections[i].id,
            id: superClientsMenu[j].id,
            name: superClientsMenu[j].name,
            isActive: isActive,
            isExpanded: isActive ? true : false,
          });
        }
      }
    }
    return menus;
  },

  getSubMenus(menus, selectedSectionId, selectedMenuId, selectedSubMenuId) {
    let subMenus = [];
    let isActive = false;
    for (let i = 0; i < menus.length; i++) {
      let currentMenu = superClientsMenu.filter((sr) => sr.id == menus[i].id);
      if (currentMenu.length > 0) {
        for (let j = 0; j < currentMenu[0].subMenu.length; j++) {
          isActive = false;
          if (
            selectedSectionId == menus[i].sectionId &&
            selectedMenuId == menus[i].id &&
            selectedSubMenuId == currentMenu[0].subMenu[j].id
          ) {
            isActive = true;
          }
          subMenus.push({
            sectionId: menus[i].sectionId,
            menuId: menus[i].id,
            id: currentMenu[0].subMenu[j].id,
            name: currentMenu[0].subMenu[j].name,
            isActive: isActive,
          });
        }
      }
    }
    return subMenus;
  },
};
